// const base_url = "https://khanglobalstudies.com/api/";
const base_url = "https://api.khanglobalstudies.com/cms";
export default base_url;
